<template>
  <j-modal
    title="答题记录"
    :width="1000"
    :visible="visible"
    :maskClosable="false"
    switchFullscreen
    :footer="null"
    @cancel="visible = false"
  >
    <questionHistory ref="questionHistory" />
  </j-modal>
</template>

<script>
import QuestionHistory from "./QuestionHistory";

export default {
  name: "QuestionHistoryModal",
  components: {
    QuestionHistory,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    open(questionId) {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.questionHistory.queryParam.questionId = questionId;
        this.$refs.questionHistory.loadData(1);
      });
    },
  },
};
</script>

<style scoped>
</style>